interface AnalyticsEvent {
  event: string;
  properties?: Record<string, any>;
  userId?: string;
}

interface UserProperties {
  userId: string;
  email?: string;
  name?: string;
  company?: string;
  plan?: string;
}

class Analytics {
  private initialized = false;
  private queue: AnalyticsEvent[] = [];

  init() {
    if (this.initialized) return;
    
    // Initialize analytics in production
    if (process.env.NODE_ENV === 'production') {
      // TODO: Initialize your analytics provider (Mixpanel, Amplitude, etc.)
      console.log('Analytics initialized');
    }
    
    this.initialized = true;
    this.flushQueue();
  }

  private flushQueue() {
    this.queue.forEach(event => this.track(event.event, event.properties, event.userId));
    this.queue = [];
  }

  track(event: string, properties?: Record<string, any>, userId?: string) {
    const eventData: AnalyticsEvent = { event, properties, userId };
    
    if (!this.initialized) {
      this.queue.push(eventData);
      return;
    }

    if (process.env.NODE_ENV === 'production') {
      // TODO: Send to your analytics provider
      console.log('Analytics Event:', eventData);
    } else {
      console.log('Analytics Event (Dev):', eventData);
    }
  }

  identify(userProperties: UserProperties) {
    if (process.env.NODE_ENV === 'production') {
      // TODO: Identify user in your analytics provider
      console.log('User Identified:', userProperties);
    } else {
      console.log('User Identified (Dev):', userProperties);
    }
  }

  page(pageName: string, properties?: Record<string, any>) {
    this.track('Page View', {
      page: pageName,
      ...properties,
      timestamp: Date.now(),
      url: window.location.href,
    });
  }

  // Key business events
  campaignCreated(campaignId: string, campaignType: string) {
    this.track('Campaign Created', {
      campaignId,
      campaignType,
      timestamp: Date.now(),
    });
  }

  callInitiated(campaignId: string, leadId: string) {
    this.track('Call Initiated', {
      campaignId,
      leadId,
      timestamp: Date.now(),
    });
  }

  callCompleted(campaignId: string, leadId: string, outcome: string, duration: number) {
    this.track('Call Completed', {
      campaignId,
      leadId,
      outcome,
      duration,
      timestamp: Date.now(),
    });
  }

  leadImported(source: string, count: number) {
    this.track('Leads Imported', {
      source,
      count,
      timestamp: Date.now(),
    });
  }

  subscriptionChanged(tier: string, action: string) {
    this.track('Subscription Changed', {
      tier,
      action, // 'upgraded', 'downgraded', 'cancelled'
      timestamp: Date.now(),
    });
  }

  featureUsed(feature: string, context?: Record<string, any>) {
    this.track('Feature Used', {
      feature,
      ...context,
      timestamp: Date.now(),
    });
  }
}

export const analytics = new Analytics();